import { mediaItems } from '@/mocks/home';

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100 scroll-mt-[72px]">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            追剧指南
          </h2>
          <p className="text-sm md:text-base text-foreground-600 mt-3 max-w-xl mx-auto">
            精选剧评、盘点与推荐，帮你发现更多值得看的电视剧
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {mediaItems.slice(0, 3).map((item) => (
            <div
              key={item.id}
              className="group bg-white rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 hover:scale-[1.02] cursor-pointer"
            >
              <div className="relative h-48 md:h-52 overflow-hidden">
                <img
                  src={item.thumbnail}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                  onError={(e) => {
                    (e.target as HTMLElement).style.display = 'none';
                  }}
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors flex items-center justify-center">
                  <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-white/90 group-hover:bg-primary-500 transition-colors">
                    <i className="ri-play-fill text-primary-500 group-hover:text-white text-xl md:text-2xl ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-3 right-3">
                  <span className="text-xs font-label font-medium bg-black/60 text-white px-2 py-0.5 rounded whitespace-nowrap">
                    {item.duration}
                  </span>
                </div>
              </div>

              <div className="p-4">
                <h3 className="text-sm md:text-base font-heading font-bold text-foreground-950 group-hover:text-primary-500 transition-colors leading-snug">
                  {item.title}
                </h3>
                <div className="flex items-center gap-2 mt-2">
                  <i className="ri-eye-line text-foreground-400 text-xs"></i>
                  <span className="text-xs text-foreground-500">{item.views} 次观看</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-6 mt-5 md:mt-6">
          {mediaItems.slice(3, 5).map((item) => (
            <div
              key={item.id}
              className="group bg-white rounded-xl overflow-hidden border border-background-200/70 hover:border-accent-200 transition-all duration-300 hover:scale-[1.02] cursor-pointer flex flex-col sm:flex-row"
            >
              <div className="relative w-full sm:w-60 h-40 sm:h-auto overflow-hidden flex-shrink-0">
                <img
                  src={item.thumbnail}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                  onError={(e) => {
                    (e.target as HTMLElement).style.display = 'none';
                  }}
                />
                <div className="absolute inset-0 bg-black/20 flex items-center justify-center">
                  <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-white/90 group-hover:bg-accent-500 transition-colors">
                    <i className="ri-play-fill text-accent-500 group-hover:text-white text-lg md:text-xl ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-2 right-2">
                  <span className="text-xs font-label font-medium bg-black/60 text-white px-2 py-0.5 rounded whitespace-nowrap">
                    {item.duration}
                  </span>
                </div>
              </div>
              <div className="p-4 flex-1 flex flex-col justify-center">
                <h3 className="text-sm md:text-base font-heading font-bold text-foreground-950 group-hover:text-primary-500 transition-colors leading-snug">
                  {item.title}
                </h3>
                <div className="flex items-center gap-2 mt-2">
                  <i className="ri-eye-line text-foreground-400 text-xs"></i>
                  <span className="text-xs text-foreground-500">{item.views} 次观看</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}